export default __webpack_public_path__ + "static/media/format-italic.4dc7c587.svg";